module.exports = __webpack_public_path__ + "assets/img/thumb-Yoobic-Landing-Page-+-Website.3708746b.jpg";